module.exports = __webpack_public_path__ + "static/media/arches.02be07c5.jpg";